import { IPartners } from '@llws/lift-entity-interfaces';
import { Equal, IQueryCommandOptions, In, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
/**
 * Fetches Client Parners <br>
 * API Endpoint - `/syndication-api/clients_partners${convertCommandToQueryString(filters)}` <br> via {@link adminRequest.get}
 */
export const getClientPartners = () => {
  const filters: IQueryCommandOptions = {
    relations: [
      {
        alias: 'p',
        path: 'partner',
      },
      {
        alias: 'rf',
        path: 'p.rentsyncFeeds',
      },
      {
        alias: 'prr',
        path: 'p.partnerRentsyncRestrictions',
      },
      {
        alias: 'prs',
        path: 'p.partnerRentsyncSettings',
      },
      {
        alias: 'plt',
        path: 'p.promotedListingTypes',
      },
      {
        alias: 'phls',
        path: 'p.partnersHasListingsSites',
      },
      {
        alias: 'ls',
        path: 'phls.listingSite',
      },
    ],
    where: [
      Equal('p.status', 'enabled'),
      In('p.syndication', ['live', 'hidden']),
    ],
    orderBy: [{ field: 'p.syndicationOrder', direction: 'asc' }, { field: 'p.name', direction: 'asc' }],
    limit: 999,
  };
  return adminRequest.get(`/syndication-api/clients_partners${convertQueryCommandToQueryString(filters)}`);
};

/**
 * Get Partner by ID
 * @param id partnerId
 * @returns Promise<IPartners, null>
 */
export const getPartnerById = (id: string) => adminRequest.get<IPartners, null>(`/syndication-api/partners/${id}`);

/**
 * Fetches LWS Parners <br>
 * API Endpoint - `/syndication-api/partners?where=partnerKey:lws`<br> via {@link adminRequest.get}
 */
export const getLwsPartner = async () => {
  const result = await adminRequest.get(`/syndication-api/partners?where=partnerKey:lws`);
  return result.data[0];
};

export default {
  getClientPartners,
  getLwsPartner,
  getPartnerById,
};
